module.exports = __webpack_public_path__ + "static/guide_klassisk.min-f2b9436bb3830da74c9c6b55f7679915.png";